import Vue from 'vue'
import Vuex from 'vuex'

// Import modules
// import landing from '../pages/Landing/store'
// import style from '../pages/style/store'
// import cabinClass from '../pages/class/store'
// import plans from '../pages/plans/store'
// import contact from '../pages/contact/store'
// import confirm from '../pages/confirm/store'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    user: [],
    wishlistType: 'giftlist',
    tabIdx: -1
  },
  actions: {
    setUserAction ({ commit }, landing) {
      commit('setUserMutation', landing)
    },
    setWishlistTypeAction ({ commit }, landing) {
      commit('setWishlistTypeMutation', landing)
    },
    setTabIndexAction ({ commit }, landing) {
      commit('setTabIndexMutation', landing)
    }

  },
  mutations: {
    setUserMutation (state, payload) {
      state.user = payload
    },
    setWishlistTypeMutation (state, payload) {
      state.wishlistType = payload
    },
    setTabIndexMutation (state, payload) {
      state.tabIdx = payload
    }
  }
  // modules: {
  //   landing

  //   // confirm
  // }
})

export default store
